import { render } from "./BaseLabel.vue?vue&type=template&id=49af3abc"
import script from "./BaseLabel.vue?vue&type=script&lang=js"
export * from "./BaseLabel.vue?vue&type=script&lang=js"
script.render = render

export default script